import * as Sentry from '@sentry/react';

import environment from '@/environment';

// Package
import appPackage from '../../package.json';

export const initialize = () => {
  const sentryDSN = environment.SENTRY_DSN;
  const sentryEnvironment = environment.SENTRY_ENVIRONMENT;

  if (sentryDSN && sentryEnvironment) {
    Sentry.init({
      dsn: sentryDSN,
      environment: sentryEnvironment,
      release: appPackage.version,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      // Performance Monitoring
      tracesSampleRate: 1.0,
      // Session Replay
      replaysSessionSampleRate: environment.SENTRY_REPLAY_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: 1.0,
      debug: environment.DEBUG,
      // Ensure all events are sent (no sampling)
      sampleRate: 1.0,
      // Limit breadcrumbs to reduce event size
      maxBreadcrumbs: 20,
    });
  }
};
